import { FaSignOutAlt } from "react-icons/fa";
import { Button } from "./styled/Button";

export const LogoutButtonPresenter = ({ handleClick }) => <Button
	onClick={handleClick}
>Sair <FaSignOutAlt /></Button>